<template>
  <section class="sc-o27kl3-0 gsZmuC product-slider-section mt-5">
    <div>
      <div class="sc-d8w7bo-1 jpdybm">
        <div direction="row" class="sc-1r3hge1-0 heMFVq scroll-example my-container" style="flex-wrap: wrap;" >
        <product-border :list="list" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import axios from 'axios';
import {defineProps, ref} from 'vue'
import ProductBorder from '../../item/ProductBorder.vue';
let props = defineProps(['group_id','storeId']);
let list = ref();
function getItems(){
  axios
  .get('https://radap.ir/Backend/api/section/pages/store/whole_groups.php?id='+props.group_id+'&shop='+props.storeId)
  .then(response =>{
    list.value = response.data;
  })
}
getItems()

</script>

<style scoped>

.sc-1q5lmzx-0{
  margin: 1px;
}
@media (max-width: 750px){
  .heMFVq > *{
    width: 33%;
  }
}
@media (max-width: 450px){
  .heMFVq > *{
    width: 49%;
  }
}



</style>